var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fieldset',{staticClass:"px-0"},[_c('legend',[_vm._v(_vm._s(_vm.t('Become VIP!')))]),_c('ChartProProgress',{attrs:{"current-level":_vm.pro.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }